import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, RouterProvider } from 'react-router-dom';
import router from './Route/index.js';
import { store } from './comp/Store/Store.js'
import { Provider } from 'react-redux'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(


     <Provider store={store}>
    <RouterProvider router={router} />
    </Provider>

);


